export const defaultValue = {
    location: ''
}